var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderLineHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 19,
    viewBox: "0 0 352 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.225 8.48039C156.96 9.19266 143.173 14.8715 129.161 17.6677C122.266 20.0391 110.903 20.3365 115.208 9.15763C87.8339 13.2015 60.2848 16.2 32.6024 15.7894C21.8738 15.1939 9.86835 16.5134 0 11.634C29.5788 14.2479 59.3714 9.9542 88.716 6.15012C98.259 4.71384 107.751 2.90471 117.276 1.31938C125.651 0.175077 132.431 -0.46907 126.407 10.6235C135.286 10.0657 185.837 -12.1527 179.034 9.36771C233.824 -0.552673 288.868 9.60853 343.928 10.3271C356.63 9.69028 352.784 14.6621 343.114 15.6852C302.71 18.2129 262.431 12.5989 222.041 12.677C207.644 12.6079 193.433 15.3628 179.164 17.0381C173.689 18.0782 171.225 13.8052 171.225 8.48039Z",
    fill: "#C83B44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderLineHeader);
export default __webpack_public_path__ + "static/media/underLineHeader.7719c4dc6db62bf0b7f993fa011d7669.svg";
export { ForwardRef as ReactComponent };